import { PREFIX } from "./event.utils";

/**
 *
 *
 *
 *
 *
 */
export const PRESENTATION_START = `${PREFIX}-presentation-start`;

/**
 *
 *
 *
 *
 *
 *
 */
export const PRESENTATION_END = `${PREFIX}-presentation-end`;

/**
 *
 *
 *
 *
 *
 *
 */
export const BEFORE_OPEN = `${PREFIX}-before-open`;

/**
 *
 *
 *
 */
export const OPEN = `${PREFIX}-open`;

/**
 *
 *
 *
 *
 */
export const FLYIN = `${PREFIX}-flyin`;

/**
 *
 *
 *
 *
 *
 */
export const AFTER_OPEN = `${PREFIX}-after-open`;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const BEFORE_CLOSE = `${PREFIX}-before-close`;

/**
 *
 *
 *
 *
 *
 */
export const CLOSE = `${PREFIX}-close`;

/**
 *
 *
 *
 *
 */
export const FLYOUT = `${PREFIX}-flyout`;

/**
 *
 *
 *
 *
 */
export const AFTER_CLOSE = `${PREFIX}-after-close`;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const CONTENT_FETCH = `${PREFIX}-content-fetch`;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const CONTENT_PARSE = `${PREFIX}-content-parse`;

/**
 *
 *
 *
 *
 *
 */
export const CONTENT_APPLY = `${PREFIX}-content-apply`;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const CONTENT_ERROR = `${PREFIX}-content-error`;

/**
 *
 *
 *
 *
 */
export const CONTENT_DISCARD = `${PREFIX}-content-discard`;
